import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {
  PROPERTY_ATTRIBUTE_CATEGORY_LISTING_FIELD,
  PROPERTY_ATTRIBUTE_CATEGORY_FEATURE,
  PROPERTY_ATTRIBUTE_LEVEL_APARTMENT_BUILDING,
} from 'common/propertyAttributeConstants';

import { LISTING_FORM_TYPE_APARTMENT_PROPERTY_ATTRIBUTES } from 'common/listingFormFields';

import { SR_API_ACTION_APARTMENT_BUILDING_DELETE } from 'api/actionTypes';

import { transformBooleanToYesNo } from 'client/helpers/formikHelpers';

import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';
import SrTable from 'client/components/SrTable';
import SrApartmentBuildingModal from 'client/components/SrApartmentBuildingModal';
import SrPropertyAttributeFeatureModal from 'client/components/SrPropertyAttributeFeatureModal';
import SrPropertyAttributeListingFieldFormModal from 'client/components/SrPropertyAttributeListingFieldFormModal';
import SrDarkModal from 'client/components/SrDarkModal';
import SrModalContent from 'client/components/SrModalContent';
import SrAdminMediaListTable from 'client/components/SrAdminMediaListTable';
import SrDataTableMedia from 'client/components/SrDataTableMedia';

import postWithState from 'client/actions/postWithState';

class SrTableApartmentBuildings extends Component {
  static propTypes = {
    apartmentId: PropTypes.number.isRequired,
    apartmentBuildings: PropTypes.array.isRequired,
    propertyAttributes: PropTypes.array.isRequired,
    onChange: PropTypes.func.isRequired,
    dispatch: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      aparmentBuildingModalProps: null,
      propertyAttributeFeatureModalProps: null,
      propertyAttributeListModalProps: null,
      editMediaModalApartmentBuilding: null,
    };
  }

  _onDeleteApartmentBuilding = (e) => {
    const { apartmentBuildings, dispatch, onChange } = this.props;
    const apartmentBuildingId = parseInt(e.target.dataset.id, 10);
    const apartmentBuilding = apartmentBuildings.find(({ id }) => id === apartmentBuildingId);

    // eslint-disable-next-line max-len
    if (
      !global.confirm(
        `Are you sure you want to delete the apartment building "${apartmentBuilding.addressStreetDisplay}"?`,
      )
    ) {
      return;
    }

    dispatch(postWithState, {
      action: SR_API_ACTION_APARTMENT_BUILDING_DELETE,
      payload: {
        apartmentBuildingId,
      },
      onSuccess: onChange,
      onError: (err) => {
        global.alert(`Error: "${err.message}"`);
      },
    });
  };

  _onChangeApartmentBuilding = () => {
    this._onCloseApartmentBuildingModal();
    this.props.onChange();
  };

  _onClickEditApartmentBuilding = (e) => {
    const { apartmentBuildings } = this.props;
    const apartmentBuildingId = parseInt(e.target.dataset.id, 10);
    this.setState({
      aparmentBuildingModalProps: {
        apartmentBuilding: apartmentBuildings.find(({ id }) => id === apartmentBuildingId),
      },
    });
  };

  _onCloseApartmentBuildingModal = () => {
    this.setState({
      aparmentBuildingModalProps: null,
    });
  };

  _onClickEditFloorPlanPropertyAttributeList = (e) => {
    const { apartmentBuildings } = this.props;
    const apartmentBuildingId = parseInt(e.target.dataset.id, 10);
    this.setState({
      propertyAttributeListModalProps: {
        apartmentBuilding: apartmentBuildings.find(({ id }) => id === apartmentBuildingId),
      },
    });
  };

  _onClosePropertyAttributeListModal = () => {
    this.setState({
      propertyAttributeListModalProps: null,
    });
  };

  _onChangePropertyAttributes = () => {
    this._onClosePropertyAttributeListModal();
    this.props.onChange();
  };

  _onClickEditPropertyAttributeFeature = (e) => {
    const apartmentBuildingId = parseInt(e.target.dataset.id, 10);
    this.setState({
      propertyAttributeFeatureModalProps: {
        apartmentBuildingId,
      },
    });
  };

  _onClosePropertyAttributeFeatureModal = () => {
    this.setState({
      propertyAttributeFeatureModalProps: null,
    });
  };

  _onChangePropertyAttributeFeature = () => {
    this._onClosePropertyAttributeFeatureModal();
    this.props.onChange();
  };

  _onClickEditApartmentBuildingMedia = (apartmentBuilding) => {
    this.setState({
      editMediaModalApartmentBuilding: apartmentBuilding,
    });
  };

  _onCloseEditFloorPlanMediaModal = () => {
    this.setState({
      editMediaModalApartmentBuilding: null,
    });
  };

  render() {
    const {
      aparmentBuildingModalProps,
      propertyAttributeFeatureModalProps,
      propertyAttributeListModalProps,
      editMediaModalApartmentBuilding,
    } = this.state;
    const { apartmentId, apartmentBuildings, propertyAttributes, dispatch } = this.props;

    return (
      <SrBox>
        <SrTable
          headers={[
            { content: 'id' },
            { content: 'street name' },
            { content: 'street number' },
            { content: 'street suffix' },
            { content: 'street display' },
            { content: 'zip' },
            { content: 'city' },
            { content: 'state' },
            { content: 'country' },
            { content: 'location' },
            { content: 'leasing office' },
            { content: 'features' },
            { content: 'attributes' },
            { content: 'media' },
            { content: 'options', width: 10 },
          ]}
          rows={apartmentBuildings.map((apartmentBuilding) => ({
            cells: [
              { content: apartmentBuilding.id },
              { content: apartmentBuilding.addressStreetName },
              { content: apartmentBuilding.addressStreetNumber },
              { content: apartmentBuilding.addressStreetSuffix },
              { content: apartmentBuilding.addressStreetDisplay },
              { content: apartmentBuilding.addressZip },
              { content: apartmentBuilding.addressCity },
              { content: apartmentBuilding.addressStateCode },
              { content: apartmentBuilding.addressCountryCode },
              {
                content:
                  apartmentBuilding.locationLatitude && apartmentBuilding.locationLongitude
                    ? `${apartmentBuilding.locationLatitude},${apartmentBuilding.locationLongitude}`
                    : '--',
              },
              { content: transformBooleanToYesNo(apartmentBuilding.hasLeasingOffice) || '--' },
              {
                content: (
                  <SrText
                    cursor="pointer"
                    color="blue300"
                    data-id={apartmentBuilding.id}
                    onClick={this._onClickEditPropertyAttributeFeature}
                  >
                    Edit Features
                  </SrText>
                ),
              },
              {
                content: (
                  <SrText
                    cursor="pointer"
                    color="blue300"
                    data-id={apartmentBuilding.id}
                    onClick={this._onClickEditFloorPlanPropertyAttributeList}
                  >
                    Edit Attributes
                  </SrText>
                ),
              },
              {
                content: (
                  <SrText
                    cursor="pointer"
                    color="blue300"
                    data-id={apartmentBuilding.id}
                    onClick={() => this._onClickEditApartmentBuildingMedia(apartmentBuilding)}
                  >
                    Edit Media
                  </SrText>
                ),
              },
              {
                content: (
                  <div>
                    <SrText
                      cursor="pointer"
                      color="blue300"
                      data-id={apartmentBuilding.id}
                      onClick={this._onClickEditApartmentBuilding}
                    >
                      Edit
                    </SrText>
                    <SrBox display="inlineBlock" width={10} />
                    <SrText
                      cursor="pointer"
                      color="blue300"
                      data-id={apartmentBuilding.id}
                      onClick={this._onDeleteApartmentBuilding}
                    >
                      Delete
                    </SrText>
                  </div>
                ),
              },
            ],
          }))}
        />
        {aparmentBuildingModalProps && (
          <SrApartmentBuildingModal
            {...aparmentBuildingModalProps}
            onChange={this._onChangeApartmentBuilding}
            onClose={this._onCloseApartmentBuildingModal}
            dispatch={dispatch}
          />
        )}
        {propertyAttributeListModalProps && (
          <SrPropertyAttributeListingFieldFormModal
            title={`Building "${propertyAttributeListModalProps.apartmentBuilding.addressStreetDisplay}"`}
            formType={LISTING_FORM_TYPE_APARTMENT_PROPERTY_ATTRIBUTES}
            propertyAttributes={propertyAttributes.filter(
              ({ category, apartmentBuildingId }) =>
                category === PROPERTY_ATTRIBUTE_CATEGORY_LISTING_FIELD &&
                apartmentBuildingId === propertyAttributeListModalProps.apartmentBuilding.id,
            )}
            apartmentId={propertyAttributeListModalProps.apartmentBuilding.apartmentId}
            apartmentBuildingId={propertyAttributeListModalProps.apartmentBuilding.id}
            onChange={this._onChangePropertyAttributes}
            onClose={this._onClosePropertyAttributeListModal}
            dispatch={dispatch}
          />
        )}
        {propertyAttributeFeatureModalProps && (
          <SrPropertyAttributeFeatureModal
            propertyAttributes={propertyAttributes.filter(
              ({ category, apartmentBuildingId }) =>
                category === PROPERTY_ATTRIBUTE_CATEGORY_FEATURE &&
                apartmentBuildingId === propertyAttributeFeatureModalProps.apartmentBuildingId,
            )}
            apartmentId={apartmentId}
            apartmentBuildingId={propertyAttributeFeatureModalProps.apartmentBuildingId}
            propertyAttributeLevel={PROPERTY_ATTRIBUTE_LEVEL_APARTMENT_BUILDING}
            onClose={this._onClosePropertyAttributeFeatureModal}
            onChange={this._onChangePropertyAttributeFeature}
            dispatch={dispatch}
          />
        )}
        {editMediaModalApartmentBuilding && (
          <SrDarkModal onClose={this._onCloseEditFloorPlanMediaModal}>
            <SrModalContent>
              <SrText size="28" weight="600" paddingBottom="10x" display="block">
                {`Media for Building ${editMediaModalApartmentBuilding.addressStreetDisplay}`}
              </SrText>
              <SrDataTableMedia apartmentBuildingId={editMediaModalApartmentBuilding.id}>
                {({ mediaList, reloadMediaList, reloadMediaById }) => (
                  <SrAdminMediaListTable
                    mediaList={mediaList}
                    reloadMediaList={reloadMediaList}
                    reloadMediaById={reloadMediaById}
                    dispatch={dispatch}
                    createMediaDefaultValues={{
                      apartmentBuildingId: editMediaModalApartmentBuilding.id,
                    }}
                    createMediaTitle={`Media for Building ${editMediaModalApartmentBuilding.addressStreetDisplay}`}
                  />
                )}
              </SrDataTableMedia>
            </SrModalContent>
          </SrDarkModal>
        )}
      </SrBox>
    );
  }
}

SrTableApartmentBuildings.displayName = 'SrTableApartmentBuildings';

export default SrTableApartmentBuildings;
